import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { PortalOrdersScreen } from '../features/orders/PortalOrdersScreen'

/** /orders/$id — карточка заказа (D14 §«Шаг 9», S35).
 *  Защищена <RequireAuth>; permission-gating + 404-сценарии — внутри экрана. */
export const Route = createFileRoute('/orders/$id/')({
  component: OrderDetailRoute,
})

function OrderDetailRoute() {
  const { id } = Route.useParams()
  const numericId = Number(id)
  return (
    <RequireAuth>
      <PortalOrdersScreen orderId={numericId} />
    </RequireAuth>
  )
}
